import React, { forwardRef, MouseEventHandler, useImperativeHandle, useRef } from "react";

import { HorizontalScrollable, IHorizontalScrollableRef } from "../../horizontal-scrollable";
import { Icon, IconName } from "../../icon";

export const BottomMenuSeparator = () => <span className="bottom-menu__seperator" />;
BottomMenuSeparator.displayName = "BottomMenuSeparator";

/** Currently we use the same interface as the child */
export type IBottomMenuButtonsRef = IHorizontalScrollableRef;

export interface IBottomMenuButton<T = string> {
	/** Required because it's used as react key */
	id: T;
	iconName: IconName;
	title?: string;
	isActive?: boolean;
	isDisabled?: boolean;
	badgeText?: string;
	onClick: MouseEventHandler<HTMLButtonElement>;
}

/** Groups buttons on a scrollable list */
export const BottomMenuButtons = forwardRef<
	IBottomMenuButtonsRef,
	React.PropsWithChildren<{
		onBack?: () => void;
		showBackButton?: boolean;
		className?: string;
		containerClassName?: string;
		fadeRight?: boolean;
	}>
>(({ onBack, showBackButton, className, containerClassName, children, fadeRight }, parentRef) => {
	const elRef = useRef<IHorizontalScrollableRef>(null);
	const backButtonRef = useRef<HTMLButtonElement>(null);

	// With useImperativeHandle we can give control to the parent
	useImperativeHandle(parentRef, () => elRef.current as IBottomMenuButtonsRef, []);

	return (
		<div className="bottom-menu__content">
			{showBackButton && (
				<button
					className="bottom-menu__back"
					onClick={onBack}
					type="button"
					ref={backButtonRef}
				>
					<Icon iconName="angle-left" />
				</button>
			)}
			<HorizontalScrollable
				ref={elRef}
				className={`bottom-menu__buttons ${className || ""}`}
				containerClassName={`bottom-menu__buttons-container ${containerClassName || ""}`}
				fadeRight={fadeRight}
			>
				{children}
			</HorizontalScrollable>
		</div>
	);
});
BottomMenuButtons.displayName = "BottomMenuButtons";
